import { NavLink } from "react-router-dom";
import BrandLockup from "../BrandLockup";
import NavMoreMenu from "../ui/NavMoreMenu";

export default function Header() {
  const linkBase =
    "pb-1 border-b-2 border-transparent transition-colors hover:text-orange-500 hover:border-orange-300";
  const linkActive = "pb-1 border-b-2 border-orange-500 text-orange-500";

  return (
    <header className="bg-black border-b border-zinc-800 relative z-20">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-2.5">
        {/* LEFT: logo */}
        <div className="flex items-center min-w-0">
          <NavLink
            to="/"
            end
            className="inline-flex items-center cursor-pointer hover:opacity-90 transition-opacity"
            aria-label="BuildBright home"
          >
            <BrandLockup />
          </NavLink>
        </div>

        {/* RIGHT: Desktop nav */}
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium">
          <NavLink
            to="/"
            end
            className={({ isActive }) => (isActive ? linkActive : `text-zinc-200 ${linkBase}`)}
          >
            Home
          </NavLink>

          <NavLink
            to="/services"
            className={({ isActive }) => (isActive ? linkActive : `text-zinc-200 ${linkBase}`)}
          >
            Services
          </NavLink>

          <NavLink
            to="/contractors/pricing"
            className={({ isActive }) => (isActive ? linkActive : `text-zinc-200 ${linkBase}`)}
          >
            For Contractors
          </NavLink>

          <NavLink
            to="/get-quotes"
            className="inline-flex items-center justify-center rounded-full bg-orange-600 px-4 py-2 text-sm font-semibold text-white shadow-none hover:bg-orange-700 active:bg-orange-800 transition"
          >
            Start Project Request
          </NavLink>

          {/* More dropdown */}
          <div className="-mt-[2px]">
            <NavMoreMenu />
          </div>
        </nav>

        {/* RIGHT: Mobile nav (no wrap) */}
        <nav className="flex md:hidden items-center gap-2">
          <a
            href="/#/get-quotes"
           className="inline-flex items-center justify-center rounded-full bg-orange-600 px-4 py-2 text-sm font-semibold text-white shadow-none hover:bg-orange-700 active:bg-orange-800 transition"
          >
           Start Project Request
          </a>

          <NavMoreMenu />
        </nav>
      </div>
    </header>
  );
}
